import { createFileRoute } from '@tanstack/react-router';
import { TextReaderPage } from '../../../../features/community-hub/components/text-reader-page';

/**
 * Community Hub - Text Reader Route
 * Path: /community-hub/text/:id
 *
 * Full-page text reader for TEXT content blocks
 */
export const Route = createFileRoute('/_protected/community-hub/text/$id')({
  component: TextReaderPage,
});
